import PropTypes from 'prop-types';
import classNames from 'classnames';

import Checkbox from '../Checkbox';

import Badge from '../Badge';

import styles from './CheckboxWithLabel.module.scss';

const CheckboxWithLabel = ({
  className = '',
  text,
  showCount = false,
  count = null,
  checked,
  labelTitle = null,
  alignTop = false,
  ...rest
}) => {
  return (
    <div
      className={classNames(styles.checkboxWithLabel, className, {
        [styles['checkboxWithLabel--top']]: alignTop
      })}
    >
      <Checkbox checked={checked} {...rest} />
      {rest.id ? (
        <label htmlFor={rest.id} className={styles.text}>
          {labelTitle && (
            <>
              <span className={styles.title}>{labelTitle}</span>
              <span> - </span>
            </>
          )}
          <span>{text}</span>
        </label>
      ) : (
        <span className={styles.text}>{text}</span>
      )}
      <span className={styles.count}>
        {showCount && !checked && (
          <Badge label={count} theme="secondary-pink-light" size="tiny" />
        )}
      </span>
    </div>
  );
};

CheckboxWithLabel.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  labelTitle: PropTypes.string,
  showCount: PropTypes.bool,
  alignTop: PropTypes.bool,
  count: PropTypes.number,
  ...Checkbox.propTypes
};

export default CheckboxWithLabel;
